import { render } from "./EditPlantDashboardPositions.vue?vue&type=template&id=6d95ea86"
import script from "./EditPlantDashboardPositions.vue?vue&type=script&lang=js"
export * from "./EditPlantDashboardPositions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__